<div class="africa-map-wrapper">
  <svg xmlns="http://www.w3.org/2000/svg"
       viewBox="434 127 247 263"
       class="africa-map-svg"
       preserveAspectRatio="xMidYMid meet">
    <g transform="matrix(0.5263,0,0,0.5263,0,0)">
      <path *ngFor="let p of paths"
            [attr.id]="p.code"
            class="country-path"
            [attr.d]="p.d"
            [attr.fill]="getCountryColor(p.code)"
            stroke="#ffffff"
            stroke-width="0.8"
            (mouseenter)="onCountryHover(p.code, $event)"
            (mousemove)="onCountryMove($event)"
            (mouseleave)="onCountryLeave()"
      />
    </g>
  </svg>

  <!-- Tooltip -->
  <div class="map-tooltip"
       *ngIf="tooltipVisible"
       [style.left.px]="tooltipX"
       [style.top.px]="tooltipY">
    <span class="tooltip-country">{{ tooltipCountry }}</span>
    <span class="tooltip-detail" *ngIf="tooltipCount > 0">
      {{ tooltipPercentage }}% &mdash; {{ tooltipCount | number }} Learners
    </span>
    <span class="tooltip-detail" *ngIf="tooltipCount === 0">
      0 Learners
    </span>
  </div>
</div>
